var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("metadata",{"key":0}," Svg Vector Icons : http://www.onlinewebfonts.com/icon "),React.createElement("g",{"key":1},React.createElement("path",{"d":"M500,990C229.4,990,10,770.6,10,500C10,229.4,229.4,10,500,10c270.6,0,490,219.4,490,490C990,770.6,770.6,990,500,990z M500,99C265.4,99,99.1,265.4,99.1,500c0,234.5,166.3,400.9,400.9,400.9c234.5,0,400.9-166.4,400.9-400.9C900.9,265.4,734.5,99,500,99z M366.4,277.2L722.7,500L366.4,722.7C366.4,714.2,366.4,309.3,366.4,277.2z"}))]);
}

Play.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 1000 1000","enableBackground":"new 0 0 1000 1000","xmlSpace":"preserve"};

module.exports = Play;

Play.default = Play;
